import * as types from "./actionTypes";
import { TOGGLE_IMPORT_EXCEL_TEAM_MODAL } from "./actionTypes";

export const getList = id => {
  return {
    type: types.GET_ACCOUNT_TITLE_REQUEST,
    id
  };
};

export const getListSuccess = data => {
  return {
    type: types.GET_ACCOUNT_TITLE_SUCCESS,
    payLoad: data
  };
};
export const getListFailure = error => {
  return {
    type: types.GET_ACCOUNT_TITLE_FAILURE,
    error: error
  };
};

export const show = id => {
  return {
    type: types.SHOW_ACCOUNT_TITLE_REQUEST,
    id
  };
};

export const showSuccess = data => {
  return {
    type: types.SHOW_ACCOUNT_TITLE_SUCCESS,
    payLoad: data
  };
};
export const showFailure = error => {
  return {
    type: types.SHOW_ACCOUNT_TITLE_FAILURE,
    error: error
  };
};

export const remove = (id, goBack) => {
  return {
    type: types.REMOVE_ACCOUNT_TITLE_REQUEST,
    id,
    goBack
  };
};

export const removeSuccess = data => {
  return {
    type: types.REMOVE_ACCOUNT_TITLE_SUCCESS,
    payLoad: data
  };
};
export const removeFailure = () => {
  return {
    type: types.REMOVE_ACCOUNT_TITLE_FAILURE
  };
};

export const store = data => {
  return {
    type: types.STORE_ACCOUNT_TITLE_REQUEST,
    data
  };
};

export const storeSuccess = data => {
  return {
    type: types.STORE_ACCOUNT_TITLE_SUCCESS,
    payLoad: data
  };
};
export const storeFailure = () => {
  return {
    type: types.STORE_ACCOUNT_TITLE_FAILURE
  };
};

export const getTypesForDefaults = () => {
  return {
    type: types.GET_TYPES_FOR_GET_DEFAULTS_ACCOUNT_TITLE_REQUEST
  };
};

export const getTypesForDefaultsSuccess = data => {
  return {
    type: types.GET_TYPES_FOR_GET_DEFAULTS_ACCOUNT_TITLE_SUCCESS,
    payLoad: data
  };
};
export const getTypesForDefaultsFailure = error => {
  return {
    type: types.GET_TYPES_FOR_GET_DEFAULTS_ACCOUNT_TITLE_FAILURE,
    error: error
  };
};

export const getDefaults = typeId => {
  return {
    type: types.GET_DEFAULTS_ACCOUNT_TITLE_REQUEST,
    typeId
  };
};

export const getDefaultsSuccess = data => {
  return {
    type: types.GET_DEFAULTS_ACCOUNT_TITLE_SUCCESS,
    payLoad: data
  };
};
export const getDefaultsFailure = error => {
  return {
    type: types.GET_DEFAULTS_ACCOUNT_TITLE_FAILURE,
    error: error
  };
};

export const toggleDefaultListModal = status => {
  return {
    type: types.TOGGLE_DEFAULT_ACCOUNT_TITLE_LIST_MODAL,
    status: status
  };
};

export const toggleImportExcelTeamModal = status => {
  return {
    type: types.TOGGLE_IMPORT_EXCEL_TEAM_MODAL,
    status: status
  };
};

export const storeDefault = data => {
  return {
    type: types.STORE_DEFAULT_ACCOUNT_TITLE_REQUEST,
    data: data
  };
};

export const storeDefaultSuccess = data => {
  return {
    type: types.STORE_DEFAULT_ACCOUNT_TITLE_SUCCESS,
    payLoad: data
  };
};
export const storeDefaultFailure = () => {
  return {
    type: types.STORE_DEFAULT_ACCOUNT_TITLE_FAILURE
  };
};

export const update = (id, data) => {
  return {
    type: types.UPDATE_ACCOUNT_TITLE_REQUEST,
    id,
    data
  };
};

export const updateSuccess = data => {
  return {
    type: types.UPDATE_ACCOUNT_TITLE_SUCCESS,
    payLoad: data
  };
};
export const updateFailure = () => {
  return {
    type: types.UPDATE_ACCOUNT_TITLE_FAILURE
  };
};

export const importFile = data => {
  return {
    type: types.IMPORT_FILE_ACCOUNT_TITLE_REQUEST,
    data
  };
};

export const importFileSuccess = data => {
  return {
    type: types.IMPORT_FILE_ACCOUNT_TITLE_SUCCESS,
    payLoad: data
  };
};
export const importFileFailure = () => {
  return {
    type: types.IMPORT_FILE_ACCOUNT_TITLE_FAILURE
  };
};

export const clearList = () => {
  return {
    type: types.CLEAR_ACCOUNT_TITLE_LIST
  };
};

export const emptyLastItem = () => {
  return {
    type: types.EMPTY_LAST_ACCOUNT_TITLE_ITEM
  };
};

export const storeSub = (accountTitleId, data) => {
  return {
    type: types.STORE_SUB_ACCOUNT_TITLE_REQUEST,
    accountTitleId,
    data
  };
};

export const storeSubSuccess = data => {
  return {
    type: types.STORE_SUB_ACCOUNT_TITLE_SUCCESS,
    payLoad: data
  };
};
export const storeSubFailure = () => {
  return {
    type: types.STORE_SUB_ACCOUNT_TITLE_FAILURE
  };
};

export const updateSub = (accountTitleId, id, data) => {
  return {
    type: types.UPDATE_SUB_ACCOUNT_TITLE_REQUEST,
    accountTitleId,
    id,
    data
  };
};

export const updateSubSuccess = data => {
  return {
    type: types.UPDATE_SUB_ACCOUNT_TITLE_SUCCESS,
    payLoad: data
  };
};
export const updateSubFailure = () => {
  return {
    type: types.UPDATE_SUB_ACCOUNT_TITLE_FAILURE
  };
};

export const removeSub = (accountTitleId, id) => {
  return {
    type: types.REMOVE_SUB_ACCOUNT_TITLE_REQUEST,
    accountTitleId,
    id
  };
};

export const removeSubSuccess = data => {
  return {
    type: types.REMOVE_SUB_ACCOUNT_TITLE_SUCCESS,
    payLoad: data
  };
};
export const removeSubFailure = () => {
  return {
    type: types.REMOVE_SUB_ACCOUNT_TITLE_FAILURE
  };
};
